import { default as deDE } from 'locales/deDE.json';

export type TranslationKey = keyof typeof deDE;

export type TransParams = { weekNumber?: number };

export enum AppLocale {
  en_US = 'en-US',
  de_DE = 'de-DE'
}
